var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('game-header',{staticClass:"pl-5 pr-6 md:px-8",attrs:{"hideProgress":""}},[_c('div',{staticClass:"flex-grow"},[_c('img',{staticClass:"vtb-logo",attrs:{"src":"/images/vtb-logo.png","alt":"vtb logo"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }